/* eslint-disable camelcase */
import { useCallback, useEffect, useMemo, useState } from 'react'
import {
  CoveragesObject,
  InsuredObjectsOutput,
  PackObjects,
} from '../../@types/RunPetisSimulation'

type _PackListType = {
  pack: PackObjects | undefined
  coverages: CoveragesObject
}

export type _InsuredObjectsType = {
  insuredObject: Pick<InsuredObjectsOutput, 'insuredObjectId' | 'insuredPet'>
  packLists: PackObjects[]
  coverages: CoveragesObject | undefined
}

export const useFormattedValueToTableRender = (
  insuredObject: InsuredObjectsOutput,
) => {
  const [update, setUpdate] = useState(true)
  const [dataFormatted, setDataFormatted] = useState<_InsuredObjectsType[]>()

  const insuredObjects = useMemo(() => [insuredObject], [insuredObject])
  const coverages = insuredObject.coveragesObject

  const packsOrdered = insuredObject?.packsObject?.packs
    ?.sort((a: any, b: any) => a.packOrder - b.packOrder)
    .map((pack) => pack.packId)

  const packsList = (packsOrdered || [])?.map((id) =>
    insuredObject?.packsObject?.packs?.find((pack) => pack.packId === id),
  )

  const formatterData = useCallback(() => {
    const _insuredObjects: _InsuredObjectsType[] = []
    const _packList: _PackListType[] = []

    insuredObjects?.forEach((insuredObject) => {
      packsList.forEach((pack) => {
        let mandatoryCoverages
        let optionalCoverages
        pack?.coverages?.forEach((packCoverage) => {
          mandatoryCoverages = coverages?.mandatoryCoverages
            ?.map((mandatoryCoverage) => {
              if (mandatoryCoverage.coverageId === packCoverage.coverageId) {
                return {
                  ...mandatoryCoverage,
                  ...packCoverage,
                }
              }

              return null
            })
            .filter((item) => item)

          optionalCoverages = coverages?.optionalCoverages
            ?.map((optionalCoverage) => {
              if (optionalCoverage.coverageId === packCoverage.coverageId) {
                return {
                  ...optionalCoverage,
                  ...packCoverage,
                }
              }

              return null
            })
            .filter((item) => item)
        })
        _packList.push({
          pack,
          coverages: {
            insuredObjectId: insuredObject.insuredObjectId,
            mandatoryCoverages,
            optionalCoverages,
          },
        })
      })

      _insuredObjects.push({
        insuredObject: {
          insuredObjectId: insuredObject.insuredObjectId,
          insuredPet: insuredObject.insuredPet,
        },
        packLists: getAllPacks(_packList),
        coverages,
      })
    })

    return _insuredObjects
  }, [coverages, insuredObjects, packsList])

  const getAllPacks = (_packLists: _PackListType[]): PackObjects[] => {
    const packs = _packLists?.map((item) => item?.pack)

    return packs as PackObjects[]
  }

  useEffect(() => {
    if (update) {
      setDataFormatted(formatterData())
      setUpdate(false)
    }
  }, [formatterData, update])

  return dataFormatted
}
